<app-header-style-seven></app-header-style-seven>

<div class="edc-page">
  <div class="custom-container">
    <section class="edc-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Innovation & Leadership</span>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>

        <div class="hero-stats">
          <div class="stat-card" *ngFor="let stat of heroStats">
            <span class="stat-label">{{ stat.label }}</span>
            <strong>{{ stat.value }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="content-head-card">
      <span class="content-tag">Institutional Cell</span>
      <h2>Entrepreneurship Development Cell (EDC)</h2>
      <p>Fatima Michael College of Engineering &amp; Technology, Madurai.</p>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>Entrepreneurship Development Cell (EDC)</h3>
        <p>
          Encouraging leadership, innovation, industry exposure, and entrepreneurial
          thinking among students.
        </p>
      </div>

      <div class="section-copy">
        <p>{{ edcIntro }}</p>
      </div>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>EDC Committee Members</h3>
        <p>
          Committee members of the Entrepreneurship Development Cell of FMCET.
        </p>
      </div>

      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Position</th>
              <th>Category</th>
              <th>Occupation</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of edcMembers">
              <td>{{ member.sno }}</td>
              <td>{{ member.name }}</td>
              <td>{{ member.position }}</td>
              <td>{{ member.category }}</td>
              <td>{{ member.occupation }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>About EDC</h3>
        <p>
          FMCET promotes entrepreneurship through leadership building, industry
          collaboration, and innovation-oriented learning.
        </p>
      </div>

      <div class="section-copy">
        <p *ngFor="let paragraph of edcParagraphs">
          {{ paragraph }}
        </p>
      </div>

      <ul class="feature-list">
        <li *ngFor="let item of edcHighlights">
          {{ item }}
        </li>
      </ul>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Leadership</span>
        <h3>Entrepreneurial Mindset for Students</h3>
        <p>
          The EDC motivates students to think creatively, lead confidently, and
          explore real opportunities in entrepreneurship and innovation.
        </p>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Industry Connect</span>
        <h3>Learn, Collaborate, Build</h3>
        <p>
          Through workshops, industry exposure, joint initiatives, and practical
          engagement, the EDC helps students grow into future-ready innovators.
        </p>
      </article>
    </section>
  </div>
</div>